export const HTTP_URL = process.env.REACT_APP_HTTP_URL
export const BASE_URL = ''
export const AI_URL = process.env.REACT_APP_AI_URL
export const NTF_IMAGES_URL = process.env.REACT_APP_NTF_IMAGES_URL
export const ENV = process.env.REACT_APP_ENV
